// NewProjectModal helpers — Patch 010.A.4 R6 split.
// Draft shape + form-field constants + per-field validators.

export const US_STATES: ReadonlyArray<{ code: string; name: string }> = [
  { code: 'MN', name: 'Minnesota' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'IA', name: 'Iowa' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'IL', name: 'Illinois' },
  { code: 'MI', name: 'Michigan' },
  { code: 'NY', name: 'New York' },
  { code: 'CA', name: 'California' },
  { code: 'TX', name: 'Texas' },
  { code: 'FL', name: 'Florida' },
]

export const ZIP_RE = /^\d{5}(-\d{4})?$/
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export type Phase = 'planning' | 'pre-construction' | 'active'

export interface Draft {
  address: string
  city: string
  state: string
  zip: string
  phase: Phase
  client_first_name: string
  client_last_name: string
  client_email: string
  client_phone: string
  has_client2: boolean
  client2_first_name: string
  client2_last_name: string
  client2_email: string
  client2_phone: string
  name_override: string | null
}

export const EMPTY: Draft = {
  address: '',
  city: '',
  state: 'MN',
  zip: '',
  phase: 'planning',
  client_first_name: '',
  client_last_name: '',
  client_email: '',
  client_phone: '',
  has_client2: false,
  client2_first_name: '',
  client2_last_name: '',
  client2_email: '',
  client2_phone: '',
  name_override: null,
}

export function formatPhone(v: string): string {
  const digits = v.replace(/\D/g, '').slice(0, 10)
  if (digits.length < 4) return digits
  if (digits.length < 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`
}
